<template>
	<el-dialog title="物流信息" append-to-body :visible.sync="dialogVisible" :close-on-click-modal="false" width="976px">
		<div style="position: relative;">
			<el-divider content-position="left">{{formObj.moduleName}}</el-divider>
		</div>
		<el-form :disabled="$route.query.state!='dsy'" :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="110px">
			<el-row :gutter="20">
				<el-col :span="12" v-for="(item, index) in formObj.list" :key="index" v-show="item.showed">
					<el-form-item :label="item.label" :prop="item.field.split('.')[1]" :rules="[
                        {
                            required: item.required,
                            message: item.label + '不能为空',
                            trigger: 'blur'
                        }
                    ]">
						<el-input v-if="item.type === 'input' || item.type === 'textarea'" v-model.trim="dataForm[item.field.split('.')[1]]"
							:disabled="item.options.disabled" placeholder="请输入" @blur="setForm(item)" :type="item.type">
						</el-input>
						<el-select v-if="item.type === 'select'" :disabled="item.options.disabled" class="w100"
							v-model="dataForm[item.field.split('.')[1]]" placeholder="请选择" @change="setForm(item)">
							<el-option :label="op.label" :value="op.code" v-for="(op, i) of item.options.valueData"
								:key="i"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div style="position: relative;">
			<el-divider content-position="left">{{tableObj.moduleName}}</el-divider>
		</div>
		<div v-loading="timelineLoading">
			<div v-if="noData" style="width: 300px;margin: 0 auto;text-align: center;margin-top: 82px;">
				<img src="@/assets/img/noData.png" height="128" width="141" />
				<p style="font-size: 24px;font-weight: bold;margin-bottom:38px;margin-top:16px;">哦豁！暂无物流信息。</p>
			</div>
			<el-timeline v-else>
				<el-timeline-item
					v-for="(activity, index) in tableObj.data"
					:key="index"
					:timestamp="activity.time">
					{{activity.status}}
				</el-timeline-item>
			</el-timeline>
		</div>
		<div slot="footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dataFormSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				timelineLoading: false,
				noData: false,
				dialogVisible: false,
				orderId: '',
				dataForm:{},
				submitFormData: {},
				expressDep:[],
				formObj:{
					list:[]
				},
				tableObj:{
					data:[]
				}
			};
		},
		methods: {
			init(orderId,pid) {
				this.timelineLoading = true;
				this.orderId = orderId;
				this.dialogVisible = true;
				let params = {
					orderId: orderId,
					stepKey: 'ORDER_WLXX',
					pid:pid
				}
				this.$http.post(this.$api.orderApi.getTimeLine, params).then(({
					data
				}) => {
					this.timelineLoading = false;
					this.formObj = data.data.moduleSList.filter(v=>v.layout == "FORM")[0];
					// this.formObj.list = this.formObj.list.filter(v => v.showed == true);
					this.tableObj = data.data.moduleSList.filter(v=>v.layout == "TABLE")[0];
					this.noData = !this.tableObj.data.length;
					this.formObj.list.forEach(item => {
						this.$set(this.dataForm, item.field.split('.')[1], item.val);
						this.$set(this.submitFormData, item.field, item.val);
					});
					this.dialogVisible = true;
				}).catch(()=>{
					this.timelineLoading = false;
				})
			},
			setForm(item) {
				this.submitFormData[item.field] = this.dataForm[item.field.split('.')[1]];
			},
			dataFormSubmit(){
				let params = {
					orderId: this.orderId
				}
				params[this.formObj.moduleNameEn] = this.submitFormData;
				this.$http.post(this.$api.orderApi.updateOrder, params).then(({
					data
				}) => {
					this.$message({
						message: data.msg,
						type: 'success'
					});
				})
			}
			
		}
	};
</script>

<style lang="scss" scoped>
.el-timeline{
	margin-left: 242px;
}
</style>
